import styled from 'styled-components';

import { Message } from '@tillersystems/stardust';

export const TopMarginMessage = styled(Message)`
  margin-top: 2rem;
`;

export const Link = styled.a`
  color: ${({ theme: { palette } }) => palette.primary.default};
`;
